import { ImageBackground } from '../../particles/image'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { SwiperZoomContainer, SwiperZoomTarget } from './swiper-zoom.styled.js'

const SwiperZoom = ({ image, alt }) => {
	return (
		<SwiperZoomContainer className="swiper-zoom-container">
			<SwiperZoomTarget className="swiper-zoom-target">
				<ImageBackground
					src={mediaUrl(image)}
					alt={alt}
					layout="fill"
					unoptimized
					objectFit="contain"
					style={{
						width: 'auto',
						height: '100svh',
					}}
				/>
			</SwiperZoomTarget>
		</SwiperZoomContainer>
	)
}

export default SwiperZoom
